import React from 'react';
import ShareLink from '@dashboard/components/ShareLink';

import Link from '@dashboard/components/Link';
import getSubdomainCheckoutUrl from '@dashboard/services/getSubdomainCheckoutUrl';
import getCustomDomainCheckoutUrl from '@dashboard/services/getCustomDomainCheckoutUrl';
import { isPreview as isPreviewEnv } from '@dashboard/services/env';

const CheckoutShareDirect = ({ page, seller, closeDialog }) => {
  const subdomainCheckoutUrl = getSubdomainCheckoutUrl(page, seller);
  const customDomainCheckoutUrl = !isPreviewEnv && getCustomDomainCheckoutUrl(page, seller);

  return (
    <div className="flex flex-col mb-4">
      <div className="text-md font-bold mb-2">Hosted page</div>

      <div>
        {customDomainCheckoutUrl && (
          <>
            <ShareLink link={customDomainCheckoutUrl} />

            <Link
              onClick={closeDialog}
              className="text-sm font-medium mr-2"
              variant="secondary"
              to={`/pages/${page._id}/customize/settings/url-slug`}
            >
              Change slug
            </Link>

            <div className="inline-block mt-4 text-sm font-medium">
              <a
                href={subdomainCheckoutUrl}
                rel="noreferrer"
                target="_blank"
                className="flex underline items-center"
              >
                Open fallback link
              </a>
            </div>
          </>
        )}

        {!customDomainCheckoutUrl && (
          <>
            <ShareLink link={subdomainCheckoutUrl} />
            <div className="mt-4 text-sm font-medium">
              <Link
                onClick={closeDialog}
                className="text-sm font-medium mr-2"
                variant="secondary"
                to={`/pages/${page._id}/customize/settings/url-slug`}
              >
                Change slug
              </Link>

              <Link className="text-sm font-medium" variant="secondary" to="/settings/domains">
                Add custom domain
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CheckoutShareDirect;
